import { AuthTokenInput } from "@/components/AuthTokenInput";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Index() {
  const navigate = useNavigate();

  const handleAdminClick = () => {
    navigate("/admin");
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-background">
      <div className="w-full max-w-sm space-y-8 text-center">
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold tracking-tight">
            Forskning om Föräldraskap i Sverige
          </h1>
          <p className="text-sm text-muted-foreground">
            Ange din åtkomstkod
          </p>
        </div>

        <div className="space-y-4">
          <AuthTokenInput />
        </div>

        <Button
          variant="ghost"
          className="w-full"
          onClick={handleAdminClick}
        >
          Gruppledare klicka här
        </Button>

        <div className="mt-8">
          <img 
            src="/logo.jpg" 
            alt="Logo" 
            className="mx-auto max-w-[200px] h-auto"
          />
        </div>
      </div>
    </div>
  );
}